// types
import { NavItemType } from 'types/menu';
import applications from './applications';
import tools from './tools';
import { HomeOutlined } from '@ant-design/icons';
import { ALL_USER_GROUPS } from 'utils/route-guard/roles-check';
import insideFifaMenuItems from 'inside-fifa/menu-items';

// ==============================|| MENU ITEMS ||============================== //
const menuItems: { items: NavItemType[] } = {
    items: [
        {
            id: '/',
            title: '',
            type: 'group',
            allowedGroups: ALL_USER_GROUPS,
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/dashboard',
                    icon: HomeOutlined,
                    allowedGroups: ALL_USER_GROUPS,
                },
            ],
        },
        applications,
        tools,
        insideFifaMenuItems,
    ],
};

export default menuItems;
